/** @format */

import React, { useState, useEffect, useRef } from 'react'

import { Button, DatePicker, Input, message, Upload } from 'antd'
import { UploadToOss } from '../../util/uploadTool';
import './index.less'
// import AliUploader from '../../component/AliUploader/linggan_aliupload'
import { updateDailyRecommend, homeClearRedis } from '../../api'

const dirname = 'caseManage/'
const imgPrefix = 'https://qingtu-image-originals.oss-cn-shanghai.aliyuncs.com'

export default () => {
  const [anliList, setAnliList] = useState(
    new Array(3).fill({
      id: '',
      cover: '',
      country: '',
      recommendWord: '',
      title: '',
    })
  )
  const [tujiList, setTujiList] = useState(
    new Array(4).fill({
      id: '',
      title: '',
    })
  )

  const [dateAnli, setDateAnli] = useState()
  const [dateTuji, setDateTuji] = useState()

  const [dateStringAnli, setDateStringAnli] = useState()
  const [dateStringTuji, setDateStringTuji] = useState()

  const [OSSData, setOssData] = useState()

  const token = {
    host: 'https://image.znzgo.com/',
    ALI_HOST: imgPrefix,
    // access_key_id: 'LTAI5t8ubGymdJDnqyAe2EM2', // oss的key_id
    // access_key_secret: 'zfkvIN3eft7FrYJqfCRDURjGxhSHcF', // oss的secret
    OSS_ENDPOINT: 'oss-cn-shanghai.aliyuncs.com', // 自己oss服务器的配置信息
    OSS_BUCKET: 'qingtu-image-originals', // 自己oss服务器的配置信息
    OSS_REGION: 'oss-cn-shanghai',
  }

  const initAnli = () => {
    setAnliList(new Array(3).fill({ id: '', cover: '' }))
    setDateAnli()
  }
  const initTuji = () => {
    setTujiList(
      new Array(4).fill({
        id: '',
        title: '',
      })
    )
    setDateTuji()
  }



  const handleSubmitAnli = () => {
    const submitList = JSON.parse(JSON.stringify(anliList))
    let paramData = submitList.filter(
      (item) =>
        item.id &&
        item.cover &&
        item.country &&
        item.title &&
        item.recommendWord
    )
    if (paramData.length < 3) {
      message.error('所有信息必填')
      return
    }
    if (!dateStringAnli) {
      message.error('请输入上架时间')
      return
    }
    paramData = paramData.map((item) => ({
      itemId: item.id,
      imgUrl: item.cover,
      country: item.country,
      title: item.title,
      recommendWord: item.recommendWord,
      showTime: dateStringAnli,
      type: 2,
    }))
    updateDailyRecommend(paramData)
      .then((res) => {
        if (res?.error?.code === 0) {
          message.success('保存成功')
          initAnli()
        } else {
          message.error(res?.data)
        }
      })
      .finally(() => { })
  }

  const handleSubmitTuji = () => {
    const submitList = JSON.parse(JSON.stringify(tujiList))
    let paramData = submitList.filter((item) => item.id)
    if (paramData.length === 0) {
      message.error('请填写案例ID，上架时间！')
      return
    }
    if (!dateStringTuji) {
      message.error('请输入上架时间')
      return
    }

    paramData = paramData.map((item) => ({
      itemId: item.id,
      showTime: dateStringTuji,
      title: item.title || '',
      type: 1,
    }))

    updateDailyRecommend(paramData)
      .then((res) => {
        if (res?.error?.code === 0) {
          message.success('保存成功')
          initTuji()
        } else {
          message.error(res?.data)
        }
      })
      .finally(() => { })
  }

  const handleAnliItemChange = (key, value, index) => {
    const tmpList = JSON.parse(JSON.stringify(anliList))
    tmpList[index][key] = value
    setAnliList(tmpList)
  }

  const handleTujiItemChange = (key, value, index) => {
    const tmpList = JSON.parse(JSON.stringify(tujiList))
    tmpList[index][key] = value
    setTujiList(tmpList)
  }
  const beforeUpload = (file, index) => {
    const img_type = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
    const img_size = file.size / 1024 / 1024;
    if (!img_type.includes(file.type)) {
      return false;
    }
    if (img_size > 50) {
      return false;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    const OssToken = token;
    reader.onloadend = async () => {
      // 使用ossupload覆盖默认的上传方法
      message.loading('上传中');
      UploadToOss({ token: OssToken }, OssToken.ALI_HOST, file)
        .then((data) => {
          let sourceLink = OssToken.host + '/' + data.name;
          handleAnliItemChange(
            'cover',
            sourceLink,
            index
          )
          console.debug('data', data)
          message.success('上传成功！')
        })
        .catch((err) => {
          message.destroy();
          message.error('上传失败，请重试~');
        })
        .finally(() => {
          message.destroy();
        });
    };

    return false;
  };
  return (
    <div className='homeTodayRecommendContainer'>
      <div className='group'>
        <div className='title'>案例：</div>
        <div className='anliGroup'>
          {anliList.map((item, index) => (
            <div className='anliItemRow' key={index}>
              <div className='label'>案例{index}:</div>
              <div className='caseId'>
                <Input
                  value={item.id}
                  className='input'
                  placeholder='请输入案例ID'
                  onChange={(e) => {
                    handleAnliItemChange('id', e.target.value, index)
                  }}
                />
              </div>
              <div className='label'>封面图:</div>
              <Upload
                // {...props}
                showUploadList={false}
                beforeUpload={(file) => beforeUpload(file, index)}
              >
                <Button
                  className='button'
                  type='primary'
                >
                  上传
                </Button>
              </Upload>

              {item.cover && (
                <div className='coverImg'>
                  <img src={`${item.cover}`} />
                </div>
              )}
              <div className='label'>国家:</div>
              <div className='country'>
                <Input
                  className='input'
                  value={item.country}
                  onChange={(e) => {
                    handleAnliItemChange('country', e.target.value, index)
                  }}
                />
              </div>
              <div className='label'>标题:</div>
              <div className='titleValue'>
                <Input
                  className='input'
                  maxLength={15}
                  value={item.title}
                  placeholder={'不超过15个字'}
                  onChange={(e) => {
                    handleAnliItemChange('title', e.target.value, index)
                  }}
                />
              </div>
              <div className='label'>推荐语:</div>
              <div className='recommendWord'>
                <Input
                  className='input'
                  maxLength={35}
                  value={item.recommendWord}
                  placeholder='不超过35个字'
                  onChange={(e) => {
                    handleAnliItemChange('recommendWord', e.target.value, index)
                  }}
                />
              </div>
            </div>
          ))}
          <div className='submitRow'>
            <div className='updateTime'>
              <div className='label'>上架日期：</div>
              <DatePicker
                showTime
                value={dateAnli}
                onChange={(date, dateString) => {
                  setDateAnli(date)
                  setDateStringAnli(dateString)
                }}
              />
            </div>
            <div className='btnGroup'>
              <Button onClick={initAnli}>取消</Button>
              <Button
                className='okBtn'
                type='primary'
                onClick={() => {
                  handleSubmitAnli()
                }}
              >
                确定
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className='group'>
        <div className='title'>图集：</div>
        <div className='tujiGroup'>
          {tujiList.map((item, index) => (
            <div className='tujiItemRow'>
              <div className='label'>图集{index}:</div>
              <Input
                value={item.id}
                className='input'
                placeholder='请输入图集ID'
                onChange={(e) => {
                  handleTujiItemChange('id', e.target.value, index)
                }}
              />
              <Input
                value={item.title}
                className='input'
                maxLength={10}
                onChange={(e) => {
                  handleTujiItemChange('title', e.target.value, index)
                }}
                placeholder='如果需要更改图集标题，请输入10字以内标题'
              />
            </div>
          ))}
        </div>
        <div className='submitRow'>
          <div className='updateTime'>
            <div className='label'>上架日期：</div>
            <DatePicker
              showTime
              value={dateTuji}
              onChange={(date, dateString) => {
                setDateTuji(date)
                setDateStringTuji(dateString)
              }}
            />
          </div>
          <div className='btnGroup'>
            <Button onClick={initTuji}>取消</Button>
            <Button className='okBtn' type='primary' onClick={handleSubmitTuji}>
              确定
            </Button>
          </div>
        </div>
      </div>
      <div className='clearRedis'>
        <Button type='danger' onClick={homeClearRedis}>
          立即更新上线
        </Button>
      </div>
      {/* <AliUploader
        id='upload_img_0'
        dirname={dirname}
        fileUploaded={(up, file, info, uploaded_object_name) => {
          message.success('上传完成')
          handleAnliItemChange(
            'cover',
            `${imgPrefix}/${uploaded_object_name}`,
            0
          )
        }}
        uploaderInit={(func) => (uploaderInit0.current = func)}
        token={token}
      />
      <AliUploader
        id='upload_img_1'
        dirname={dirname}
        fileUploaded={(up, file, info, uploaded_object_name) => {
          message.success('上传完成')
          handleAnliItemChange(
            'cover',
            `${imgPrefix}/${uploaded_object_name}`,
            1
          )
        }}
        uploaderInit={(func) => (uploaderInit1.current = func)}
        token={token}
      />
      <AliUploader
        id='upload_img_2'
        dirname={dirname}
        fileUploaded={(up, file, info, uploaded_object_name) => {
          message.success('上传完成')
          handleAnliItemChange(
            'cover',
            `${imgPrefix}/${uploaded_object_name}`,
            2
          )
        }}
        uploaderInit={(func) => (uploaderInit2.current = func)}
        token={token}
      /> */}
    </div>
  )
}
